module.exports = __webpack_public_path__ + "static/Walker-e08986c12d5bfdf2b375018a67064aa4.jpg";